import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import NotFound from "./pages/NotFound";
import redirects from "./seo/redirects.json";
import Home from "./pages/Home";
import Europe from "./pages/Europe";
import Escape from "./pages/Escape";
import Admin from "./pages/Admin";
import TermsPage from "./pages/Terms";
import Landing from "./pages/Landing";
import Press from "./pages/Press";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import { ScrollToTop } from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/press" element={<Press />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/getaway" element={<Home />} />
          <Route path="/europe" element={<Europe />} />
          <Route path="/escape" element={<Escape />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/terms" element={<TermsPage />} />
          {Object.entries(redirects).map(([from, to]) => (
            <Route key={from} path={from} element={<Navigate to={to} replace />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
